// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3aqS1","productName":"Table_productName__1RxlO"};